/* @flow */

import React from 'react';
import { Icon } from 'semantic-ui-react';
import { DEFAULT_BLOCK_ICON } from 'edito/constants';

const styles = {
  image: {
    minHeight: '100px',
    display: 'flex',
    background: '#e0e1e2',
  },
  icon: {
    margin: 'auto',
    fontSize: '4em',
    color: '#fff',
    lineHeight: '1em',
  },
};

type Props = {
  templates: Array<EditorialBlockTemplate>,
  block: EditorialBlock,
};

const BlockTemplateImage = ({ templates, block }: Props) => {
  const template = templates.find(t => t.code === block.template);
  const icon = template ? template.icon : DEFAULT_BLOCK_ICON;

  return (
    <div className="ui small image" style={styles.image}>
      <Icon name={icon} style={styles.icon} />
    </div>
  );
};

export default BlockTemplateImage;



// WEBPACK FOOTER //
// ./src/modules/edito/components/BlockTemplateImage.js